<template>
  <vue-drawer-layout
      ref="drawer"
      :drawer-width="300"
      @mask-click="closeDrawer">
    <div slot="drawer">
      <NavigationDrawer :close="closeDrawer" class="navigation-drawer"/>
    </div>
    <div slot="content" class="root-pane">
      <NavigationBar :toggle="openDrawer" class="nav"/>
      <div class="navigation-route-view">
        <router-view/>
      </div>
    </div>
  </vue-drawer-layout>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import NavigationBar from '../navigation/NavigationBar.vue';
import NavigationDrawer from '../navigation/NavigationDrawer.vue';

/** Minimal drawer ref API used by vue-drawer-layout. */
interface DrawerRef {
  toggle: (open?: boolean) => void;
}

/**
 * Dashboard shell — drawer navigation, top bar, and nested router-view.
 */
export default defineComponent({
  name: 'Layout',
  components: { NavigationDrawer, NavigationBar },
  /**
   * Layout setup — controls drawer open/close via template ref.
   */
  setup() {
    const drawer = ref<DrawerRef | null>(null);

    /** Opens the navigation drawer. */
    function openDrawer(): void {
      drawer.value?.toggle();
    }

    /** Closes the navigation drawer. */
    function closeDrawer(): void {
      drawer.value?.toggle(false);
    }

    return { drawer, openDrawer, closeDrawer };
  },
});
</script>

<style lang="scss" scoped>
.root-pane {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}
.navigation-drawer {
  min-width: 280px;
  width: 100%;
  height: 100vh;
}
.navigation-route-view {
  flex: 1;
  overflow-y: auto;
  transition: 0.3s ease;
}
.offline-banner {
  position: sticky;
  top: 0;
  background: var(--ct-secondary);
  color: white;
  padding: 8px 16px;
  text-align: center;
  font-weight: 500;
  font-size: 0.875rem;
}
</style>